import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import LegalAgreementError from '../shared/LegalAgreementModal/LegalAgreementError';
import AuthApp from '../AuthApp';
import '../../styles/global.scss';

type Props = {};

const Router: React.FC<Props> = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact={true} path="/" component={AuthApp} />
        <Route path="/error" component={LegalAgreementError} />
        <Route path="/*" component={AuthApp} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
